/**
 * Feature Flags Configuration
 * 
 * Toggle features on/off without code changes
 * Set to true to enable, false to disable
 */

export const FEATURES = {
  // Blog functionality
  BLOG_ENABLED: true, // Blog enabled
  
  // Other features (for future use)
  CHAT_ENABLED: true,
  ADMIN_ENABLED: true,
};

export default FEATURES;
